import {tagSvg as Icon__small__tagSvg} from '../Icon__small/Icon__small--tag.js';
import {tagSvg as Icon__xsmall__tagSvg} from '../Icon__xsmall/Icon__xsmall--tag.js';

export var tag = {
  name: 'tag',
  category: 'icon',
  colorable: true,
  svg: Icon__small__tagSvg,
  alt: {
    Icon__small: Icon__small__tagSvg,
    Icon__xsmall: Icon__xsmall__tagSvg,
  },
  combined: ['Icon__small', 'Icon__xsmall'],
};
